import { render, staticRenderFns } from "./purchaseDetail.vue?vue&type=template&id=c0fb394a&scoped=true"
import script from "./purchaseDetail.vue?vue&type=script&lang=js"
export * from "./purchaseDetail.vue?vue&type=script&lang=js"
import style0 from "./purchaseDetail.vue?vue&type=style&index=0&id=c0fb394a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0fb394a",
  null
  
)

export default component.exports